import React from 'react';
import MeetingListHighlight from '../../components/misc/MeetingListHighlight.jsx';
import MeetingContextEdit from '../../components/misc/MeetingContextEdit.jsx';
import ReactMarkdown from 'react-markdown';

const MeetingContext = ({
    calendarMeetingId,
    calendarMeetingUserContext,
    calendarMeetingAIContext,
    highlightText,
    noEdit = false
}) => {
    const renderContext = () => {
        if (calendarMeetingUserContext !== null && calendarMeetingUserContext?.trim() !== '') {
            return (
                <div className='text-theme1-text1 mt-1 whitespace-pre-wrap'>
                    <ReactMarkdown>{calendarMeetingUserContext}</ReactMarkdown>
                </div>
            );
        }

        if (
            calendarMeetingUserContext === null &&
            calendarMeetingAIContext &&
            calendarMeetingAIContext?.trim() !== ''
        ) {
            return (
                <MeetingListHighlight text={highlightText}>
                    <div className='text-theme1-text1 mt-1 whitespace-pre-wrap'>
                        <ReactMarkdown>{calendarMeetingAIContext}</ReactMarkdown>
                    </div>
                </MeetingListHighlight>
            );
        }

        return <div className='text-theme1-title2 px-4'>No context found</div>;
    };

    const contextToEdit =
        calendarMeetingUserContext !== null && calendarMeetingUserContext?.trim() !== ''
            ? calendarMeetingUserContext
            : calendarMeetingAIContext;

    return (
        <>
            {renderContext()}
            {!noEdit && <MeetingContextEdit calendarMeetingId={calendarMeetingId} context={contextToEdit} />}
        </>
    );
};

export default MeetingContext;
